<template>
    <label v-if="titleElement" :class="titleClass" :for="id">
        {{ titleElement }}
        <span class="text-primary" v-if="isRequired">*</span>
    </label>

    <div :class="onHasIcon">
        <span v-if="iconDir === 'left'" class="input-group-text" :class="classIcon">
            <i :class="onGetIcon"></i>
        </span>

        <input
            type="text"
            class="form-control vf-input"
            :class="totalyClass"
            :name="name"
            :id="id"
            :placeholder="placeholder"
            :value="modelValue"
            :disabled="disabled"
            :ref="id"
            :valid="valid"
            @input="onUpdateModelValue"
            :data-automation="`input-${ id }`"
            :minlength="minLength"
            :maxlength="maxLength"
        />

        <span v-if="iconDir === 'right'" class="input-group-text" :class="classIcon">
            <i :class="onGetIcon"></i>
        </span>
    </div>

    <span v-if="textBelow || errorMessage"
          :class="[ classBelow, { 'text-danger': errorMessage }]"
    >
        {{ textBelow || errorMessage }}
    </span>
</template>

<script>
    import { onMounted } from 'vue';
    import { formProps } from '@/mixins';
    import { useVFInput } from '@/composables';

    export default {
        name: 'VFInputText',
        mixins: [
            formProps
        ],
        setup(props, { emit }) {
            const {
                errorMessage,
                totalyClass,
                valid,
                onGetClasses,
                onGetIcon,
                onHasIcon,
                onUpdateModelValue
            } = useVFInput(props, emit);

            onMounted(()=>{
                totalyClass.value = onGetClasses(valid.value);
            });

            return {
                errorMessage,
                totalyClass,
                valid,
                onGetIcon,
                onHasIcon,
                onUpdateModelValue
            };
        }
    };
</script>
